import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../../../../components/layout/Breadcrumb";
import { fetchTicketById, addComment, getTicketDoc } from "../../../../redux/slice/supportSlice";
import { useForm } from "react-hook-form";
import CommentSection from "../../../../features/portal/support/components/CommentSection";
import { toast, ToastContainer } from "react-toastify";
import ProfileUpdateSectionEmployee from "../components/ProfileUpdateSectionEmployee";

export default function TicketDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const authUser = useSelector((state) => state.auth?.user);

  const InitialPermissionData = useSelector(
    (state) => state.persistedReducer?.forms?.savedPermissions
  );

  const currentUser = authUser || {
    id: InitialPermissionData?.userId,
    employeeId: InitialPermissionData?.employeeId,
    email: InitialPermissionData?.email,
    role: InitialPermissionData?.role,
  };

  //console.log("current user=========", currentUser);

  //console.log('current user=========', currentUser)
  const { selectedTicket, loading, error, createLoading: commentLoading } =
    useSelector((state) => state.support);

  const [activeTab, setActiveTab] = useState("conversation");
  const [message, setMessage] = useState("");
  const [selectedFile, setSelecftoasttedFile] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    formState: { errors },
  } = useForm();

  const fileInputRef = useRef(null);

  /* ================= FETCH ================= */
  useEffect(() => {
    if (id) {
      dispatch(fetchTicketById(id));
    }
  }, [dispatch, id]);

  /* ================= DEBUG ================= */
  useEffect(() => {
    console.log("ID:", id);
    console.log("Ticket:", selectedTicket);
    console.log("Loading:", loading);
    console.log("Error:", error);
  }, [id, selectedTicket, loading, error]);

  /* ================= HELPERS ================= */
  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const formatLabel = (value) => {
    if (!value) return "";
    return value
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleDownloadDoc = async (ticketId, fileName, fileType) => {
    try {
      const responseData = await dispatch(
        getTicketDoc({ ticketId, fileName, fileType })
      ).unwrap();

      // Determine the correct MIME type
      let mimeType = 'application/octet-stream'; // Default
      if (fileType.toLowerCase() === 'pdf') mimeType = 'application/pdf';
      else if (['png', 'jpg', 'jpeg'].includes(fileType.toLowerCase())) {
        mimeType = `image/${fileType.toLowerCase() === 'jpg' ? 'jpeg' : fileType.toLowerCase()}`;
      }

      // Create the Blob from the responseData
      const fileBlob = new Blob([responseData], { type: mimeType });

      // Checks if blob has size 0, then API didn't send the file correctly
      if (fileBlob.size === 0) {
        toast.error("File content is empty!");
        return;
      }

      const fileURL = window.URL.createObjectURL(fileBlob);
      const newTab = window.open(fileURL, "_blank");
      if (newTab) newTab.focus();

      // Clean up memory after a longer delay to ensure the tab has loaded
      setTimeout(() => window.URL.revokeObjectURL(fileURL), 10000);

    } catch (err) {
      console.error("Blob Error:", err);
      toast.error(err || "Failed to render document!", { className: 'toast-error-custom' });
    }
  };

  const ticket = selectedTicket || {};
  const approvedFields =
    ticket.fieldApprovals
      ?.filter((item) => item.isApproved)
      ?.map((item) => item.fieldGroupName) || [];
  const comments = Array.isArray(ticket.comments) ? ticket.comments : [];
  const auditLogs = Array.isArray(ticket.auditLogs) ? ticket.auditLogs : [];
  const showProfileUpdateTab = ticket.category === "PROFILE_UPDATE";

  return (
    <div className="container-fluid" style={{ marginBottom: "30px" }}>
      <Breadcrumb
        overrideTrail={[
          { name: "Dashboard", path: "/admin/dashboard" },
          { name: "Support", path: "/admin/support" },
          { name: `Ticket (${ticket?.id || id})` },
        ]}
      />

      <div className="section-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header border-0 bg-white pb-4">

              {/* BACK BUTTON */}
              <button type="button"
                className="btn btn-link text-decoration-none mb-3 ps-0 fw-medium primary-btn"
                onClick={() => navigate("/admin/support/")}>
                ← Back to tickets
              </button>

              {/* LOADING */}
              {loading && <p className="server-error-msg">Loading ticket details...</p>}

              {/* NO DATA */}
              {!loading && !ticket.id && (
                <p className="server-error-msg">No ticket data found</p>
              )}

              {/* MAIN CONTENT */}
              {!loading && ticket.id && (
                <div className="view-support_ticket-body">

                  {/* LEFT */}
                  <section className="conversation-container">
                    <div className="header-wrapper">
                      <div className="tocket-title d-flex justify-content-between">
                        <h2 className="issue-title mb-2">
                          {ticket.title || "-"}
                        </h2>
                      </div>

                      <div className="title-row">
                        <span className="ticket-id">
                          <label className="text-secondary-dark font-weight-bold">Ticket ID: </label> #TKT-{ticket.id}
                        </span>
                      </div>

                      <div className="meta-grid">
                        <div className="meta-item">
                          <label className="text-secondary-dark font-weight-bold  mb-0">Name:</label>
                          <div className="meta-value">
                            {ticket.createdByName || "-"}
                          </div>
                        </div>

                        <div className="meta-item">
                          <label className="text-secondary-dark font-weight-bold mb-0">Created:</label>
                          <div className="meta-value">
                            {formatDate(ticket.createdAt)}
                          </div>
                        </div>

                        <div className="meta-item">
                          <label className="text-secondary-dark font-weight-bold mb-0">Assigned To:</label>
                          <div className="meta-value">
                            {ticket.assignedToName || "-"}
                          </div>
                        </div>
                      </div>

                      <hr className="divider" />
                      <div>
                        <div className="description-grid">
                          <label className="text-secondary-dark font-weight-bold">Issue Description:</label>
                          <p className="issue-description">
                            {ticket.description || "-"}
                          </p>
                        </div>
                        <div className="view-attachment-grid">
                          <label className="text-secondary-dark font-weight-bold">View Attachment:</label>
                          <div className="attachment-container">
                            {ticket.attachments && ticket.attachments.length > 0 ? (
                              ticket.attachments.map((file) => (
                                <div key={file.id} className="attachment-badge">
                                  <i className="fa fa-file-pdf-o me-2"></i>
                                  <button
                                    type="button"
                                    className="btn btn-link attachment-link p-0"
                                    onClick={() => handleDownloadDoc(ticket.id, file.fileName, file.fileType)}
                                  >
                                    {file.fileName}
                                  </button>
                                </div>
                              ))
                            ) : (
                              <p className="mb-1 server-error-msg">-- No attachments provided --</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* TABS */}
                    <div className="tabs">
                      <button type="button" className={`tab ${activeTab === "conversation" ? "active" : ""}`}
                        onClick={() => setActiveTab("conversation")}
                      >
                        Conversation
                      </button>

                      {showProfileUpdateTab && (
                        <button type="button" className={`tab ${activeTab === "profileUpdates" ? "active" : ""}`}
                          onClick={() => setActiveTab("profileUpdates")}
                        >
                          Profile Updates
                        </button>
                      )}

                      <button
                        type="button"
                        className={`tab ${activeTab === "activity" ? "active" : ""}`}
                        onClick={() => setActiveTab("activity")}
                      >
                        Ticket Activity
                      </button>
                    </div>

                    <div className="messages-area p-0">

                      {/* PROFILE UPDATES */}
                      {activeTab === "profileUpdates" && (
                        <ProfileUpdateSectionEmployee ticket={ticket} />
                      )}

                      {/* CONVERSATION */}
                      {activeTab === "conversation" && (
                        <CommentSection
                          comments={comments}
                          loading={commentLoading}
                          activeTab={activeTab}
                          currentUser={currentUser}
                          ticket={ticket}
                          onSend={async (payload) => {
                            try {
                              await dispatch(addComment({ ticketId: id, payload })).unwrap();
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                        />
                      )}

                      {/* ACTIVITY */}
                      {activeTab === "activity" &&
                        <div className="timeline-content p-3">
                          {auditLogs.length === 0 ? (
                            <p className="server-error-msg">--No activity found--</p>
                          ) : (
                            <div className="activity-timeline">
                              {auditLogs?.map((log, index) => (
                                <div className="timeline-item" key={log.id}>

                                  {/* Left Timeline */}
                                  <div className="timeline-left">
                                    <div className="timeline-dot">
                                      {log?.performedByName?.charAt(0)}
                                    </div>

                                    {index !== auditLogs.length - 1 && (
                                      <div className="timeline-line"></div>
                                    )}
                                  </div>

                                  {/* Right Content */}
                                  <div className="timeline-content">

                                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                      <div>
                                        <h6 className="mb-1 fw-bold">
                                          {formatLabel(log.performedByName)}
                                        </h6>
                                        <div className="d-flex align-items-center flex-wrap gap-2">
                                          <span className={`activity-badge ${log.action}`}>
                                            {formatLabel(log.action)}
                                          </span>
                                          {log.fromStatus && (
                                            <span className="status-flow">
                                              {formatLabel(log.fromStatus)}
                                              <i className="fa fa-arrow-right mx-2"></i>
                                              {formatLabel(log.toStatus)}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                      <small className="text-muted fw-medium">
                                        {formatDate(log.performedAt)}
                                      </small>
                                    </div>
                                    {log.remarks && (
                                      <div className="remarks-box mt-3">
                                        {formatLabel(log.remarks)}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      }
                    </div>
                  </section>

                  {/* RIGHT */}
                  <div className="details-sidebar">
                    <div className="sidebar-card">
                      <h3>Ticket Details</h3>
                      <div className="detail-group">
                        <label>Status: </label>
                        <span className="badge status-purple">
                          {formatLabel(ticket.status || "-")}
                        </span>
                      </div>
                      <div className="detail-group">
                        <label>Priority: </label>
                        <span className="badge priority-red">
                          {ticket.priority || "-"}
                        </span>
                      </div>
                      <div className="detail-group">
                        <label>Category: </label>
                        <span>{formatLabel(ticket.category)}</span>
                      </div>
                    </div>
                    {ticket.subCategories && (
                      <div className="sidebar-card">
                        <h3>Profile Update Request</h3>
                        <div className="profile-fields">
                          {ticket.subCategories.split(",").map((item, index) => (
                            <label key={index} className="checkbox-item">
                              <input type="checkbox" checked readOnly />
                              {formatLabel(item)}
                            </label>
                          ))}
                        </div>
                      </div>
                    )}
                    {approvedFields.length > 0 && (
                      <div className="sidebar-card">
                        <h3>Accepted by HR</h3>

                        <div className="profile-fields">
                          {approvedFields.map((item, index) => (
                            <label key={index} className="checkbox-item">
                              <input type="checkbox" checked readOnly />
                              {formatLabel(item)}
                            </label>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <ToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
}